import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            重磅推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            编辑团队精选，本季不容错过的口碑大作
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselData.map((item, index) => (
            <div
              key={index}
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer hover:shadow-md transition-shadow duration-300"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              </div>
              <div className="p-5">
                <span className="text-xs text-accent-600 font-medium whitespace-nowrap">
                  {item.category}
                </span>
                <h3 className="mt-2 font-heading text-lg font-semibold text-foreground-900">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}